module.exports = __webpack_public_path__ + "real-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/real-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/real-logo.png
// module chunks = 7